import { EERIE } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import EnrollmentNotificationSettingsForm from 'automation-ui-canvas/components/settings/v2/EnrollmentNotificationSettingsForm';
import makeDefaultNotificationConfigsMap from 'automation-ui-canvas/containers/settings/utils/makeDefaultNotificationConfigsMap';
import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollmentNotificationSetting = ({
  readOnly,
  settings: {
    notifications
  },
  onChange,
  scrollTo
}) => {
  const manualEnrollmentConfig = notifications ? notifications.notificationConfigs.ENROLLMENT_DIGEST : makeDefaultNotificationConfigsMap().ENROLLMENT_DIGEST;
  const aiBasedEnrollmentConfig = notifications ? notifications.notificationConfigs.AI_BASED_ENROLLMENT_DIGEST : makeDefaultNotificationConfigsMap().AI_BASED_ENROLLMENT_DIGEST;
  const handleManualEnrollmentConfigChange = useCallback(updatedNotificationConfig => {
    const updatedNotificationSetting = Object.assign({}, notifications);
    updatedNotificationSetting.notificationConfigs.ENROLLMENT_DIGEST = updatedNotificationConfig;
    onChange({
      notifications: updatedNotificationSetting
    });
    if (updatedNotificationConfig.isEnabled) {
      setTimeout(() => scrollTo('notificationRecipientsSetting'), 100);
    }
  }, [notifications, onChange, scrollTo]);
  const handleAIBasedEnrollmentConfigChange = useCallback(updatedNotificationConfig => {
    const updatedNotificationSetting = Object.assign({}, notifications);
    updatedNotificationSetting.notificationConfigs.AI_BASED_ENROLLMENT_DIGEST = updatedNotificationConfig;
    onChange({
      notifications: updatedNotificationSetting
    });
    if (updatedNotificationConfig.isEnabled) {
      setTimeout(() => scrollTo('notificationRecipientsSetting'), 100);
    }
  }, [notifications, onChange, scrollTo]);
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "top",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.enrollmentNotificationSetting.v2.enrollmentNotificationSettingHelp.header"
        }), /*#__PURE__*/_jsxs(UIList, {
          styled: true,
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "settingsV2.enrollmentNotificationSetting.v2.enrollmentNotificationSettingHelp.ai"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "settingsV2.enrollmentNotificationSetting.v2.enrollmentNotificationSettingHelp.manual"
            })
          })]
        })]
      }),
      children: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.enrollmentNotificationSetting.v2.title"
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "info",
          color: EERIE,
          className: "m-left-1"
        })]
      })
    }),
    body: /*#__PURE__*/_jsx(EnrollmentNotificationSettingsForm, {
      aiBasedEnrollmentConfig: aiBasedEnrollmentConfig,
      manualEnrollmentConfig: manualEnrollmentConfig,
      readOnly: readOnly,
      handleManualEnrollmentConfigChange: handleManualEnrollmentConfigChange,
      handleAIBasedEnrollmentConfigChange: handleAIBasedEnrollmentConfigChange
    })
  });
};
export default EnrollmentNotificationSetting;